import { statesList, countiesList } from '../model/StaticVariables';
import { OneMapApiDataService } from '../model/OneMapApiDataService';
import { DataGrid } from '@material-ui/data-grid';
import { useState, useContext, useEffect, useCallback, createRef } from 'react';
import { InterfaceContext } from '../model/InterfaceProvider';
import * as LQ from '../controller/LayerQueries';
import TableGridColumns from '../model/TableColumns';
import { GridToolbar, GridToolbarColumnsButton, GridToolbarDensitySelector, GridToolbarContainer } from '@material-ui/data-grid';
import { tableDataMapping } from '../model/DataTransformation';

const TableGrid = () => {
    const [rows, setRows] = useState([]);
    const [columns, setcolumns] = useState([]);
    const { scope, tract, theme, usState, year, tab, setTableData, setFipsInView, highlightedFips, setErrorMessage } = useContext(InterfaceContext);
    const wrapDiv = createRef();
    const [loading, setLoading] = useState(true);
    const { showDownloadModal } = useContext(InterfaceContext);
    const tableToolbar = () => {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <GridToolbarDensitySelector />
            </GridToolbarContainer>
        );
    };
    const dataToTable = useCallback(
        (data) => {
            // ΔVΔVΔ: Map table data input with local column data
            const TableColumns = TableGridColumns[year.columns];
            const TableGridColumnKeys = Object.keys(TableColumns).map((key) => key.toLowerCase());
            const cols = Object.keys(data[0])
                .reduce((output, col, i) => {
                    const slug = col.toLowerCase();
                    var order = TableGridColumnKeys.indexOf(slug);
                    if (order === -1) return output;
                    const columnProps = TableColumns[col] || TableColumns[slug] || TableColumns[col.toUpperCase()]; // || TableColumns[headerName];
                    const adjCol = Object.assign({ field: col, width: 200, minWidth: 50, cellClassName: columnProps?.class, headerClassName: columnProps?.class }, columnProps, { order });
                    output.push(adjCol);
                    return output;
                }, [])
                .sort((a, b) => {
                    return a.order - b.order;
                });
            setcolumns(cols);
            if (highlightedFips) {
                let findHighlightInd = data.findIndex((d) => d.FIPS === highlightedFips + '');
                if (findHighlightInd > 0) {
                    if (findHighlightInd) {
                        let a, b, c;
                        a = data.slice(0, findHighlightInd);
                        b = data.slice(findHighlightInd, findHighlightInd + 1);
                        c = data.slice(findHighlightInd + 1);
                        data = [...b, ...a, ...c];
                    }
                }
            }
            setRows(data);
        },
        [LQ, scope, theme, tract, usState, year]
    );
    const getData = useCallback(async () => {
        setLoading(true);
        const DS = new OneMapApiDataService();
        const useFips = usState?.id ? [usState.id] : false; //countyFips;
        if (rows.length === 0) {
            var firstPage = await DS.getFirstPageTableData({ scope, tract, theme, usState, year: year.label, fips: useFips })
                .then((res) => {
                    return tableDataMapping(res);
                })
                .catch((err) => {
                    setErrorMessage(err.modalMessage, err);
                    return [];
                });
            if (firstPage?.length) {
                dataToTable(firstPage);
                setLoading(false);
            }
        }
        setFipsInView(useFips);

        var data = await DS.getTableData({ scope, tract, theme, usState, year: year.label, fips: useFips })
            .then((res) => {
                return tableDataMapping(res);
            })
            .catch((err) => {
                setErrorMessage(err.modalMessage, err);
                return [];
            });
        if (data?.length) {
            dataToTable(data);
        }
        document.querySelector('.MuiDataGrid-window')?.setAttribute('tabindex', 0);
        setLoading(false);
    }, [LQ, scope, theme, tract, usState, year]);
    const openDocumentation = () => {
        window.open(year.docs + '#page=' + year.varpage);
    };

    useEffect(() => {
        setTableData(rows);
    }, [rows]);

    useEffect(() => {
        if (tab.slug !== 'data') return; //don't fetch data if table is nt being viewed
        if (!tract) return;
        getData();
    }, [scope, theme, tract, usState, year, tab]);
    return (
        <div ref={wrapDiv} id="data-table" className={loading ? 'is_loading' : ''} style={{ height: 250, width: '50%' }}>
            <div className={'download-grid'}>
                <button
                    onClick={() => {
                        openDocumentation();
                    }}
                >
                    View Data Dictionary
                </button>
                <button
                    onClick={() => {
                        showDownloadModal();
                    }}
                >
                    Download
                </button>
            </div>
            <DataGrid getRowClassName={(params) => `${params.row.FIPS === highlightedFips ? 'highlight' : ''}`} columns={columns} rows={rows} loading={loading} components={{ Toolbar: tableToolbar }} />
        </div>
    );
};

export default TableGrid;
